import React from 'react';
import styled from 'styled-components';
import { Tooltip } from '@material-ui/core';
const StyledCard = styled.div`
  display: flex;
  background-color: #fff;
  justify-content: space-around;
  align-items: center;
  min-width: 100px;
  height: 32px;
  border-radius: 3px;
  padding: 0 8px;

  &:not(:last-of-type) {
    margin-right: 16px;
  }
`;
const StyledHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0 3px;
`;
const StyledHeader = styled.div`
  font-size: 10px;
  font-weight: 400;
  color: #8d8d8d;
`;
const StyledTitle = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #000;
  width: 72px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
const StyledScorePill = styled.div`
  color: #fff;
  background-color: ${props => props.bgColor};
  font-size: 12px;
  border-radius: 2px;
  text-align: center;
  font-weight: 700;
  padding: 10px 0;
  width: 24px;
  height: 16px;
  line-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
`;

const CardDetails = ({
  header,
  title,
  riskScore,
  backgroundColor
}) => {
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: title
  }, /*#__PURE__*/React.createElement(StyledCard, null, /*#__PURE__*/React.createElement(StyledHeaderContainer, null, header && /*#__PURE__*/React.createElement(StyledHeader, null, header), /*#__PURE__*/React.createElement(StyledTitle, null, title)), /*#__PURE__*/React.createElement(StyledScorePill, {
    bgColor: backgroundColor
  }, riskScore)));
};

export default CardDetails;